import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from './utils/cn';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold text-xs transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    defaultVariants: {
      variant: 'default',
    },
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground',
        destructive: 'border-transparent bg-destructive text-destructive-foreground',
        outline: 'text-foreground',
        outlineDefault: 'border-primary/10 bg-primary/5 text-primary',
        outlineDisabled: 'border bg-muted/60 text-muted-foreground',
        outlineSecondary: 'border-[#EA580B]/10 bg-[#EA580B]/5 text-[#EA580B]',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
      },
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
